import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-html-video-player',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './html-video-player.component.html',
    styleUrl: './html-video-player.component.scss',
})
export class HtmlVideoPlayerComponent {
    @Input() public htmlVideoPath: string | null | undefined;

    @Output() public readonly watched = new EventEmitter<void>();
}
